<template>
  <!-- PC表示 -->
  <div
    class="sidebar d-none d-lg-flex">
    <nav
      class="side-nav p-3 pt-6">
      <ul
        class="side-nav__list side-nav__list--scrollable list-unstyled"
        style="position: fixed;">
        <li class="side-nav__item mb-4">
          <div
            class="side-nav__item">
            <img
              src="@/assets/images/logo@2x.png"
              class="side-nav__logo">
          </div>
        </li>
        <li
          v-if="!isParentMember"
          class="side-nav__item">
          <router-link
            :to="homeRoute"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': currentPageIs(homeRoute)}">
            <span class="side-nav__icon material-icons">
              home
            </span><span class="side-nav__text">ホーム</span>
          </router-link>
        </li>
        <li
          v-if="!isParentMember"
          class="side-nav__item">
          <router-link
            to="/search"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': currentPageIs('/search')}">
            <span class="side-nav__icon material-icons">
              search
            </span><span class="side-nav__text">検索</span>
          </router-link>
        </li>
        <li
          v-if="!isParentMember"
          class="side-nav__item">
          <router-link
            to="/notifications"
            class="side-nav__link pt-3 pb-3"
            style="position: relative;"
            :class="{'side-nav__link--current': currentPageIs('/notifications')}">
            <img
              v-if="hasNotifications"
              src="@/assets/images/notification-badge.svg"
              class="notification-badge--pc">
            <span class="side-nav__icon material-icons">
              notifications
            </span><span class="side-nav__text">通知</span>
          </router-link>
        </li>
        <li
          v-if="isParentMember"
          class="side-nav__item">
          <router-link
            to="/members"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': currentPageIs('/members')}">
            <span class="side-nav__icon material-icons">
              people
            </span><span class="side-nav__text">メンバー</span>
          </router-link>
        </li>
        <li
          v-if="isAnyManager"
          class="side-nav__item">
          <router-link
            to="/admin/records"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': isRecordListPage}">
            <span class="side-nav__icon material-icons">
              group
            </span><span class="side-nav__text">記録一覧</span>
          </router-link>
        </li>
        <li
          v-if="isAnyManager"
          class="side-nav__item">
          <router-link
            to="/admin/template_management/"
            class="pt-3 pb-3 side-nav__link"
            data-testid="template-management-nav"
            :class="{'side-nav__link--current': isTemplatePage}">
            <span class="side-nav__icon material-icons">
              edit_note
            </span><span class="side-nav__text">テンプレ</span>
          </router-link>
        </li>
        <template v-if="canAccessEvents">
          <li
            v-if="isParentMember"
            class="side-nav__item">
            <div
              v-if="currentPageIs('/events')"
              class="side-nav__link pt-3 pb-3 side-nav__link--current"
              @click="refreshPage">
              <span class="side-nav__icon material-icons">
                refresh
              </span><span class="side-nav__text">更新</span>
            </div>
            <router-link
              v-else
              to="/events"
              class="pt-3 pb-3 side-nav__link">
              <span class="side-nav__icon material-icons">
                refresh
              </span><span class="side-nav__text">更新</span>
            </router-link>
          </li>
          <li
            v-else
            class="side-nav__item">
            <router-link
              to="/events"
              class="pt-3 pb-3 side-nav__link"
              :class="{'side-nav__link--current': currentPageIs('/events')}">
              <span class="side-nav__icon material-icons">
                event
              </span><span class="side-nav__text">予定表</span>
            </router-link>
          </li>
        </template>
        <li class="side-nav__item">
          <router-link
            to="/settings"
            class="pt-3 pb-3 side-nav__link"
            :class="{'side-nav__link--current': currentPageIs('/settings')}">
            <span class="side-nav__icon material-icons">
              settings
            </span><span class="side-nav__text">設定</span>
          </router-link>
        </li>
      </ul>
    </nav>
    <!-- PC表示 end -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

// テンプレート管理と、そこから遷移する各テンプレートの画面
const TEMPLATE_PAGE_PATHS = [
  '/admin/template_management',
  '/admin/note_templates',
  '/admin/mandala_goal_templates',
]

// 単純な前方一致だと /admin/note_templates_xxx のような別画面まで含んでしまう
function isUnderPath(path, base) {
  return path === base || path.startsWith(`${base}/`)
}

export default {
  computed: {
    ...mapState('auth', ['user']),
    ...mapState(['hasNotifications']),
    ...mapGetters('auth', ['canAccessEvents', 'isParentMember', 'isAnyManager']),
    homeRoute() {
      if (!this.user){
        return '/'
      }
      return `/members/${this.user.id}`
    },
    isRecordListPage() {
      return isUnderPath(this.$route.path, '/admin/records')
    },
    isTemplatePage() {
      return TEMPLATE_PAGE_PATHS.some(base => isUnderPath(this.$route.path, base))
    },
  },
  methods: { 
    currentPageIs(path) {
      return this.$route.path === path
    },
    refreshPage() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
// 項目が増えて高さの低い PC 画面（1366x768 のノート PC など）では下の項目が画面外に切れるため、
// はみ出したときだけスクロールさせる。引くのは ul の上にある nav の pt-6 の分
.side-nav__list--scrollable {
  max-height: calc(100vh - #{$spacer * 2.5});
  overflow-x: hidden;
  overflow-y: auto;
  // 幅 80px しかないのでスクロールバーで項目が折り返さないよう隠す（ホイール・トラックパッドで操作できる）
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.notification-badge--pc {
  position: absolute;
  top: 15%;
  left: 67%;
}
</style>